import {Unit} from "./unit";
import {bignumber} from "mathjs";

export interface DensityUnit extends Unit {

}

export const DensityUnitApi: DensityUnit = {
  roundingIncrement: bignumber("0.1")
}

export const DensityUnitRelative: DensityUnit = {
  roundingIncrement: bignumber("0.0001")
}

export const DensityUnitKgm3: DensityUnit = {
  roundingIncrement: bignumber("0.1")
}
